/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_564094d2","_564094d2",""]'><div :class='["","_564094d2",""]'><cube-button @_click="showPicker" :class='["","_564094d2",""]'>basic-picker</cube-button><cube-time-picker-popup ref="__mpx_ref_picker__" title="时间选择器" sub-title="请选择具体的时间" cancel-txt="返回" confirm-txt="确定" :min="(min)" :max="(max)" :show-now="(showNow)" @change='(e)=>__invoke(e, [["onChange"]])' @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' :class='["","_564094d2",""]'/><div :class='["demo-data","_564094d2",""]' v-if="(confirmParams.length || valueChangeParams.length)"><div :class='["key","_564094d2",""]'>其他事件可打开控制台查看输出</div><template v-if="(confirmParams.length)"><div :class='["key","_564094d2",""]'>confirmParams 事件参数：</div><div :class='["value","_564094d2",""]'><div v-for="(item, index) in (confirmParams)" :key="item.index" :class='["value-item","_564094d2",""]'><div :class='["item-key","_564094d2",""]'>{{item[0]}}</div><div :class='["item-value","_564094d2",""]'>{{item[1]}}</div></div></div></template><template v-if="(valueChangeParams.length)"><div :class='["key","_564094d2",""]'>valueChange 事件触发次数：{{ valueChangeCount }}</div><div :class='["key","_564094d2",""]'>valueChangeParams 事件参数：</div><div :class='["value","_564094d2",""]'><div v-for="(item, index) in (valueChangeParams)" :key="item.index" :class='["value-item","_564094d2",""]'><div :class='["item-key","_564094d2",""]'>{{item[0]}}</div><div :class='["item-value","_564094d2",""]'>{{item[1]}}</div></div></div></template></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_564094d2"}'>
.event-params,
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

.key
  margin-bottom: 10px
  font-size: 16px
.key-introduce
  margin-bottom: 10px
  line-height: 20px
.value
  margin-bottom: 20px
  white-space: break-spaces
  .value-item
    display flex
    justify-content: space-between
    height: 25px
    line-height: 25px
    font-size: 15px
    .item-value
      white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_564094d2"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_564094d2"}
  /** script content **/
  require("./basic-picker.mpx.js?isComponent&outputPath=components%2Fbasic-picker564094d2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./basic-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbasic-picker564094d2%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_564094d2"],
    ctorType: "component",
    outputPath: "components/basic-picker564094d2/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-time-picker-popup':getComponent(require("../../../packages/mpx-cube-ui/src/components/time-picker-popup/index.mpx?isComponent&outputPath=components%2Findex07b2fcda%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>